module.exports = __webpack_public_path__ + "static/media/setting.b7427a28.svg";